// Module
var code = `<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="purchases.ContractSubscriptionsCount"></bfg-chart>
    </div>
</div>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="purchases.ContractSubscriptionsByDAUCount"></bfg-chart>
    </div>
</div>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="purchases.ContractSubscriptionsPurchaseCount"></bfg-chart>
    </div>
</div>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="purchases.ContractSubscriptionsByDAUPurchaseCount"></bfg-chart>
    </div>
</div>
`;
// Exports
module.exports = code;